import React, { useRef, useEffect } from "react";
import { Card } from "reactstrap";
import { Link } from "react-router-dom";
import { PROFILE } from "../../../constants/RoutesUrl.js";
import { BiEditAlt, BiRepost, BiUserVoice } from "react-icons/bi";
import { RiDeleteBinLine } from "react-icons/ri";
import { AiOutlineUserAdd, AiOutlineUserDelete } from "react-icons/ai";
import { MdOutlineReport } from "react-icons/md";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { TbMailPlus } from "react-icons/tb";
import { FaRegShareFromSquare } from "react-icons/fa6";
import { BsBookmark, BsBookmarkFill } from "react-icons/bs";
import { RepostCard } from "./PostFooter.jsx";
import "./PostHeaderDropdown.css";

const PostHeaderDropdown = ({
  postDetails,
  postDropDown,
  dropDownId,
  type,
  isSave,
  isShare,
  shares_count,
  isFollow,
  isOwner,
  user_id,
  lang,
  handleSave,
  handleRepost,
  handleFollow,
  setReportModal,
  setEditModal,
  setDeleteModal,
  setShowPost,
  editWebinarTab,
  handlePostSelect,
  setInviteWebinar,
  setWebinarType,
  setShareModal,
  setIsOpen,
  isOpen,
  toggleRepostModal,
  setEditPostInput,
  from,
  closeDetailModal
}) => {
  const collapseRef = useRef(null);
  const RepostCollapse = useRef(null);
  const RepostbuttonRef = useRef(null);
  const [ignoreNextOutsideClick, setIgnoreNextOutsideClick] = React.useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ignoreNextOutsideClick) {
        setIgnoreNextOutsideClick(false);
        return;
      }

      const isClickInsideCollapse = collapseRef.current?.contains(event.target);
      const isClickInsideRepostCollapse = RepostCollapse.current?.contains(event.target);
      const dotsButton = document.querySelector(".dots-button");
      const isClickInsideDotsButton = dotsButton?.contains(event.target);
      const isClickInsidePopup = document.querySelector(".modal.d-block")?.contains(event.target);

      // Only close if the click is outside all relevant elements
      if (
        !isClickInsideCollapse &&
        !isClickInsideDotsButton &&
        !isClickInsideRepostCollapse &&
        !isClickInsidePopup
      ) {
        setIsOpen(false);
      }
    };

    if (postDropDown || isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [postDropDown, isOpen, ignoreNextOutsideClick, setIsOpen]);

  const handleMenuItemClick = (callback) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIgnoreNextOutsideClick(true);
    if (callback) callback();
  };

  const repostTitle = isOwner
    ? `${shares_count || 0} ${lang?.repost || "Reposts"}`
    : `${isShare ? (lang?.reposted || "Reposted") : (lang?.repost || "Repost")}`;

  const handleRepostClick = (e) => {
    e.stopPropagation();
    const pid = postDetails?.original_id || postDetails?.id;
    if (type !== "poll") {
      if (!isOwner) {
        handleRepost(pid);
      } else {
        toggleRepostModal(pid);
      }
    } else {
      if (isOwner) {
        toggleRepostModal(pid);
      } else {
        if (!isShare) {
          setIsOpen(!isOpen);
        } else {
          handleRepost(pid);
        }
      }
    }
  };

  const isMenuOpen =
    postDropDown &&
    (postDetails?.original_id === dropDownId || postDetails?.id === dropDownId);
  if (!isMenuOpen) return null;

  return (
    <div
      ref={collapseRef}
      className="mr-post-dropdown-menu"
      onClick={(e) => {
        e.stopPropagation();
        setIgnoreNextOutsideClick(true);
      }}
    >
      {/* ── Webinar: Follow / Unfollow ── */}
      {type === "webinar" && !isOwner && (
        <button
          type="button"
          className={`mr-post-dropdown-item ${isFollow ? "mr-post-dropdown-item--danger" : ""}`}
          onClick={handleMenuItemClick(() => handleFollow(postDetails?.user?.id))}
        >
          <span className="mr-post-item-icon">
            {isFollow ? <AiOutlineUserDelete /> : <AiOutlineUserAdd />}
          </span>
          <span className="mr-post-item-label">
            {isFollow ? (lang?.unfollow || "Unfollow") : (lang?.follow || "Follow")}
          </span>
        </button>
      )}

      {/* ── Webinar: Owner Actions (Invites / Host) ── */}
      {type === "webinar" && isOwner && (
        <>
          <button
            type="button"
            className="mr-post-dropdown-item"
            onClick={handleMenuItemClick(() => setInviteWebinar(true))}
          >
            <span className="mr-post-item-icon">
              <TbMailPlus />
            </span>
            <span className="mr-post-item-label">
              {lang?.send_invites || "Send Invites"}
            </span>
          </button>
          <button
            type="button"
            className="mr-post-dropdown-item"
            onClick={handleMenuItemClick(() => {
              setInviteWebinar(true);
              setWebinarType("host");
            })}
          >
            <span className="mr-post-item-icon">
              <BiUserVoice />
            </span>
            <span className="mr-post-item-label">
              {lang?.set_host || "Set Host"}
            </span>
          </button>
        </>
      )}

      {/* ── Standard Post Actions: Save & Repost ── */}
      {type !== "webinar" && (
        <>
          <button
            type="button"
            className={`mr-post-dropdown-item ${isSave ? "mr-post-dropdown-item--saved" : ""}`}
            onClick={handleMenuItemClick(() => handleSave(postDetails?.original_id || postDetails?.id))}
          >
            <span className="mr-post-item-icon">
              {isSave ? <BsBookmarkFill /> : <BsBookmark />}
            </span>
            <span className="mr-post-item-label">
              {isSave ? (lang?.saved || "Saved") : (lang?.save || "Save Post")}
            </span>
          </button>

          <button
            type="button"
            ref={RepostbuttonRef}
            className={`mr-post-dropdown-item ${(isShare || postDetails?.isShare) ? "mr-post-dropdown-item--reposted" : ""}`}
            onClick={handleRepostClick}
          >
            <span className="mr-post-item-icon">
              <BiRepost size={20} />
            </span>
            <span className="mr-post-item-label">
              {repostTitle}
            </span>
          </button>
        </>
      )}

      {/* ── Edit Post (Owner only) ── */}
      {postDetails?.user?.id === user_id && type !== "poll" && type !== "clinical-image" && postDetails?.status !== 1 && (
        <button
          type="button"
          className="mr-post-dropdown-item"
          onClick={handleMenuItemClick(() => {
            setEditPostInput(postDetails?.caption);
            if (type === "webinar") {
              setShowPost(true);
              editWebinarTab(true);
              handlePostSelect(postDetails);
            } else {
              setEditModal(true);
            }
          })}
        >
          <span className="mr-post-item-icon">
            <BiEditAlt />
          </span>
          <span className="mr-post-item-label">
            {lang?.edit || "Edit Post"}
          </span>
        </button>
      )}

      {/* ── About This Account ── */}
      <Link
        to={`${PROFILE}/${postDetails?.user?.id}`}
        className="mr-post-dropdown-item"
        onClick={() => {
          if (closeDetailModal) closeDetailModal(true);
        }}
      >
        <span className="mr-post-item-icon">
          <IoMdInformationCircleOutline />
        </span>
        <span className="mr-post-item-label">
          {lang?.about_this_account || "About this account"}
        </span>
      </Link>

      {/* ── Share ── */}
      <button
        type="button"
        className="mr-post-dropdown-item"
        onClick={handleMenuItemClick(() => setShareModal(true))}
      >
        <span className="mr-post-item-icon">
          <FaRegShareFromSquare />
        </span>
        <span className="mr-post-item-label">
          {lang?.share || "Share"}
        </span>
      </button>

      {/* ── Divider Before Destructive Actions ── */}
      <div className="mr-post-dropdown-divider" />

      {/* ── Delete (Owner) ── */}
      {postDetails?.user?.id === user_id && (
        <button
          type="button"
          className="mr-post-dropdown-item mr-post-dropdown-item--danger"
          onClick={handleMenuItemClick(() => setDeleteModal(true))}
        >
          <span className="mr-post-item-icon">
            <RiDeleteBinLine />
          </span>
          <span className="mr-post-item-label">
            {lang?.delete || "Delete Post"}
          </span>
        </button>
      )}

      {/* ── Report (Non-Owner) ── */}
      {postDetails?.user?.id !== user_id && (
        <button
          type="button"
          className="mr-post-dropdown-item mr-post-dropdown-item--danger"
          onClick={handleMenuItemClick(() => setReportModal(true))}
        >
          <span className="mr-post-item-icon">
            <MdOutlineReport />
          </span>
          <span className="mr-post-item-label">
            {lang?.report || "Report Post"}
          </span>
        </button>
      )}

      {/* ── Poll Repost Card Popover ── */}
      <div ref={RepostCollapse}>
        {isOpen && (
          <Card
            style={{
              position: "absolute",
              top: "96px",
              left: "-15px",
              zIndex: 1100,
              width: "308px",
              boxShadow: "0 12px 36px -6px rgba(15, 23, 42, 0.16)",
              borderRadius: "16px",
              border: "1px solid #E2E8F0",
              overflow: "hidden",
            }}
          >
            <RepostCard
              repost={handleRepost}
              original_id={postDetails?.original_id}
              toggleCollapse={() => setIsOpen(false)}
              pollData={postDetails}
            />
          </Card>
        )}
      </div>
    </div>
  );
};

export default PostHeaderDropdown;
